import React from 'react'
export const ENV = process.env.ENVIRONMENT ? process.env.ENVIRONMENT : 'DEV'
export const LOCALE = process.env.LOCALE ? process.env.LOCALE : 'es-CO'

export const infoData = {
  'es-CO': [
    <>
      <span>Mediremos el tiempo</span> y entre menos te demores, más puntos
      ganarás.
    </>,
    <>
      <span>Por cada segundo</span> que te sobre en el juego, acumularás 1
      punto.
    </>,
    <>
      <span>Si redimes y participas</span> varias veces, acumulas más puntaje.
    </>,
    <>
      <span>Participa las veces que quieras</span> redimiendo 30 puntos cada
      vez.
    </>,
    <>
      <span>Recuerda que el tiempo es oro</span>, pues los segundos que te
      sobren al buscar nuestros personajes, serán sumados a tu marcador.
    </>,
    <>
      Una vez termines de ubicar correctamente todos los personajes,{' '}
      <span>haz clic en “Finalizar juego”</span> y el tiempo restante será
      sumado a tus puntos.
    </>,
  ],
  'es-CL': [
    <>
      <span>Mediremos el tiempo</span> y entre menos te demores, más puntos
      ganarás.
    </>,
    <>
      <span>Por cada segundo</span> que te sobre en el juego, acumularás 1
      punto.
    </>,
    <>
      <span>Si canjeas y participas</span> varias veces, acumulas más puntaje.
    </>,
    <>
      <span>Participa las veces que quieras</span> canjeando 20 puntos cada vez.
    </>,
    <>
      <span>Recuerda que el tiempo es oro</span>, pues los segundos que te
      sobren al buscar nuestros personajes, serán sumados a tu marcador.
    </>,
    <>
      Una vez termines de ubicar correctamente todos los personajes,{' '}
      <span>haz clic en “Finalizar juego”</span> y el tiempo restante será
      sumado a tus puntos.
    </>,
  ],
  'es-AR': [
    <>
      <span>Mediremos el tiempo,</span> cuanto menos tardes. más puntos ganarás.
    </>,
    <>
      <span>Si canjeás y participás varias veces,</span> acumularás más puntaje.
    </>,
    <>
      <span>Participá las veces que quieras.</span>
    </>,
    <>
      <span>Recordá que el tiempo vale oro</span>, los segundos que te sobren al
      buscar nuestros personajes, serán sumados a tu marcador.
    </>,
    <>
      Una vez termines de ubicar correctamente todos los personajes,{' '}
      <span>hacé clic en “Finalizar juego”</span> y el tiempo restante será
      sumado a tus puntos.
    </>,
  ],
  'es-PY': [
    <>
      <span>Mediremos el tiempo,</span> cuanto menos tardes, más puntos ganarás.
    </>,
    <>
      <span>Si canjeás y participás varias veces,</span> acumularás más puntaje.
    </>,
    <>
      <span>Participá las veces que querás.</span>
    </>,
    <>
      <span>Recordá que el tiempo vale oro</span>, los segundos que te sobren al
      buscar nuestros personajes, serán sumados a tu marcador.
    </>,
    <>
      Una vez termines de ubicar correctamente todos los personajes,{' '}
      <span>hacé clic en “Finalizar juego”</span> y el tiempo restante será
      sumado a tus puntos.
    </>,
  ],
  'es-DO': [
    <>
      <span>Mediremos el tiempo</span> y entre menos te demores, más puntos
      ganarás.
    </>,
    <>
      <span>Por cada segundo</span> que te sobre en el juego, acumularás 1
      punto.
    </>,
    <>
      <span>Si redimes y participas</span> varias veces, acumulas más puntaje.
    </>,
    <>
      <span>Participa las veces que quieras</span> redimiendo 20 puntos cada
      vez.
    </>,
    <>
      <span>Recuerda que el tiempo es oro</span>, pues los segundos que te
      sobren al buscar nuestros personajes, serán sumados a tu marcador.
    </>,
    <>
      Una vez termines de ubicar correctamente todos los personajes,{' '}
      <span>haz clic en “Finalizar juego”</span> y el tiempo restante será
      sumado a tus puntos.
    </>,
  ],
  'es-PR': [
    <>
      <span>Mediremos el tiempo</span> y entre menos te demores, más puntos
      ganarás.
    </>,
    <>
      <span>Por cada segundo</span> que te sobre en el juego, acumularás 1
      punto.
    </>,
    <>
      <span>Recuerda que el tiempo es oro</span>, pues los segundos que te
      sobren al buscar nuestros personajes, serán sumados a tu marcador.
    </>,
    <>
      Una vez termines de ubicar correctamente todos los personajes,{' '}
      <span>haz clic en “Finalizar juego”</span> y el tiempo restante será
      sumado a tus puntos.
    </>,
  ],
  'es-BO': [
    <>
      Participa <span>las veces que quieras.</span>
    </>,
    <>
      <span>Recuerda que el tiempo es oro</span>
    </>,
    <>
      Una vez termines de ubicar correctamente todos los personajes,{' '}
      <span>haz clic en “Finalizar juego”.</span>
    </>,
  ],
}[LOCALE]
